export const INVEST_ELIGIBILITY = 'Check Btc Eligibility';
export const INVEST_OPEN_ONBOARDING = 'Open Invest Onboarding';
export const INVEST_CREATE_UPDATE_WITHHOLDING = 'Btc Withholding Create/Update';
export const INVEST_LINK_CASH = 'Link Cash Account';
export const INVEST_CHECK_TWO_FACTOR = 'Check 2fa';
export const INVEST_TWO_FACTOR = '2fa Enrollment';
export const INVEST_SET_CONVERSION = 'Set Conversion Amount';
export const INVEST_COMPLETE_ONBOARDING = 'Complete Onboarding';
export const INVEST_CHECK_LEGAL_ENTITY = 'Legal Entity Check';
export const INVEST_SET_ACCOUNT_RELATIONSHIP = 'Set Account Relationship';
export const INVEST_SET_WAITLISTED = 'Seller Waitlisted';
export const INVEST_SET_CASH_LINKING_GRANT = 'Set Cash Linking Grant';
export const INVEST_VIEW_BTC_UPSELL = 'View Btc Upsell';
export const INVEST_ADD_TO_INELIGIBLE_WAITLIST = 'Add to Btc Ineligibility Waitlist';